<template>
  <h1 class="title has-text-centered">
    <go-to-dashboard-button />

    {{ $tc("vending.category", 2) }}&nbsp;

    <button class="button" @click="$emit('get-vending-categories')">
      <b-icon icon="sync-alt"></b-icon>
    </button>

    &nbsp;
    <button class="button" @click="$emit('add-vending-category')">
      <b-icon icon="plus-circle" type="is-primary"></b-icon>
    </button>
    <hr />
  </h1>
</template>

<script>
import goToDashboardButton from "../common/GoToDashboardButton";

export default {
  components: {
    goToDashboardButton
  },

  data() {
    return {
      isLoading: false
    };
  }
};
</script>

<style scoped>
hr {
  background-color: hsl(0, 0%, 71%);
}
</style>
